import { useEffect, useRef, useState } from 'react';
import { hapticFeedback } from '../lib/twa.js';

export default function ReasonModal({ open, title, body, confirmLabel, cancelLabel = 'Cancel', minLength = 3, maxLength = 500, onConfirm, onCancel }) {
  const [value, setValue] = useState('');
  const [error, setError] = useState(null);
  const inputRef = useRef(null);

  useEffect(() => {
    if (open) {
      setValue('');
      setError(null);
      const t = setTimeout(() => inputRef.current?.focus(), 30);
      return () => clearTimeout(t);
    }
    return undefined;
  }, [open]);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') onCancel?.();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onCancel]);

  if (!open) return null;

  const trimmed = value.trim();
  const charsLeft = maxLength - value.length;
  const tooShort = trimmed.length < minLength;
  const tooLong = value.length > maxLength;

  function submit() {
    if (tooShort) {
      setError(`Reason must be at least ${minLength} characters`);
      hapticFeedback('warning');
      return;
    }
    if (tooLong) {
      setError(`Reason must be at most ${maxLength} characters`);
      hapticFeedback('warning');
      return;
    }
    onConfirm?.(trimmed);
  }

  return (
    <div className="modal-backdrop" onClick={onCancel} role="presentation">
      <div className="modal" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true">
        <div className="modal-title">{title}</div>
        {body && <div className="modal-body">{body}</div>}
        <textarea
          ref={inputRef}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          maxLength={maxLength + 50}
          placeholder="Type your reason…"
          rows={4}
        />
        <div className="modal-meta">
          <span className={tooShort ? 'error' : ''}>{trimmed.length}/{minLength}+ chars</span>
          <span className={charsLeft < 0 ? 'error' : ''}>{charsLeft} left</span>
        </div>
        {error && <div className="error">{error}</div>}
        <div className="modal-actions">
          <button className="ghost" onClick={onCancel}>{cancelLabel}</button>
          <button onClick={submit} disabled={tooShort || tooLong}>{confirmLabel}</button>
        </div>
      </div>
    </div>
  );
}
